/**
 * Lease Helper Utilities — Pure functions for lease status computation
 */

// Returns days remaining until end_date (null if no end_date)
export const getDaysRemaining = (lease) => {
  if (!lease || !lease.end_date) return null;
  const end = new Date(lease.end_date);
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  return Math.ceil((end - now) / (1000 * 60 * 60 * 24));
};

// Returns boolean — is the lease expiring within `days` (default 30)?
export const isExpiringSoon = (lease, days = 30) => {
  if (!lease || lease.status !== "active") return false;
  const rem = getDaysRemaining(lease);
  return rem !== null && rem >= 0 && rem <= days;
};

// Returns display status including derived `expiring_soon`
export const getLeaseStatus = (lease) => {
  if (!lease) return null;
  if (lease.status === "active" && isExpiringSoon(lease)) return "expiring_soon";
  return lease.status; // draft, active, expired, terminated
};

// Find active or draft lease for a given tenant
export const getLeaseForTenant = (leases, tenantId) => {
  if (!leases || !tenantId) return null;
  return leases.find(l => l.tenant_id === tenantId && (l.status === "active" || l.status === "draft")) || null;
};

// Find active or draft lease for a given property
export const getLeaseForProperty = (leases, propertyId) => {
  if (!leases || !propertyId) return null;
  return leases.find(l => l.property_id === propertyId && (l.status === "active" || l.status === "draft")) || null;
};

// Returns theme color for status badge
export const leaseStatusColor = (status, h) => {
  switch (status) {
    case "active": return h.gn;
    case "draft": return h.sc;
    case "expiring_soon": return h.wn;
    case "expired": return h.rd;
    case "terminated": return h.rd;
    default: return h.sc;
  }
};

// Returns translated label for status
export const leaseStatusLabel = (status, t) => {
  switch (status) {
    case "active": return t.leaseActive;
    case "draft": return t.leaseDraft;
    case "expiring_soon": return t.expiringSoon;
    case "expired": return t.leaseExpired;
    case "terminated": return t.leaseTerminated;
    default: return status;
  }
};

// Returns true if a payment month string (e.g. "Feb 25") is before the current month
export const isOverdue = (moStr) => {
  if (!moStr) return false;
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const parts = moStr.split(" "); if (parts.length < 2) return false;
  const payMonth = new Date(2000 + Number(parts[1]), months.indexOf(parts[0]), 1);
  const now = new Date(); const curMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  return payMonth < curMonth;
};
